export const portalIconProgress = (value) => {
  let r = 77;
  let c = Math.PI * (r * 2);
  let showStar = value > 0 ? true : false;
  let opacity = value == 100 ? '1' : '0.25';

  if (value < 0) {
    value = 0;
  }
  if (value > 100) {
    value = 100;
  }

  let pct = ((100 - value) / 100) * c;

  return {
    dashArray: c,
    dashOffset: pct,
    opacity: opacity,
    showStar: showStar,
  };
};

export const buyerSituationAnswer = (value) => {
  if (value == 'time_constrained') {
    return 'I’m looking to move in as soon as possible.';
  } else if (value == 'first_time_buyer') {
    return 'I’m looking for my first home.';
  } else if (value == 'second_home') {
    return 'I’m looking for a new home that better fits my needs.';
  } else if (value == 'forever_home') {
    return 'I’m looking for my forever home.';
  } else {
    return 'You have not provided a reason for looking for a home';
  }
};

export const getPlannerContent = (plannerProgress) => {
  let PlannerContent = {
    DashboardCTAContent: {
      label: '',
      headline: '',
      content: '',
      buttons: [{ link: '', text: '' }],
    },
    PlannerCTAContent: {
      headline: '',
      link: '',
    },
  };

  if (!plannerProgress) {
    return null;
  }

  if (
    plannerProgress?.find((item) => item.section == 'Budget')
      ?.percentCompleted === 0 &&
    plannerProgress.find((item) => item.section == 'Home Aspirations')
      ?.percentCompleted === 0 &&
    plannerProgress?.find((item) => item.section == 'Home Buying Journey')
      ?.percentCompleted === 0 &&
    plannerProgress?.find((item) => item.section == 'Land')
      ?.percentCompleted === 0
  ) {
    PlannerContent = {
      DashboardCTAContent: {
        label: 'First Up',
        headline: 'Getting Started',
        content:
          'Use our home buying planner to move through the home buying journey. Complete the planner in the order most comfortable to you.',
        buttons: [{ link: '/portal/planner/', text: 'Explore Planner' }],
      },
      PlannerCTAContent: {
        headline: 'Learn about the home buying journey',
        link: '/portal/home-buying-journey/',
      },
    };
  }
  ///Home Buying Journey///
  else if (
    plannerProgress?.find((item) => item.section == 'Home Buying Journey')
      ?.percentCompleted !== 100
  ) {
    PlannerContent = {
      DashboardCTAContent: {
        label: 'Next Up',
        headline: 'The home buying journey',
        content:
          'Budget, land and home needs can all impact your overall timeline. Know what to expect as you move through the home buying journey.',
        buttons: [
          { link: '/portal/home-buying-journey/', text: 'Explore Planner' },
        ],
      },
      PlannerCTAContent: {
        headline: 'Learn about the home buying journey',
        link: '/portal/home-buying-journey/',
      },
    };
  }
  ///Budget///
  else if (
    plannerProgress?.find((item) => item.section == 'Budget')
      ?.percentCompleted !== 100
  ) {
    PlannerContent = {
      DashboardCTAContent: {
        label: 'Next Up',
        headline: 'Determine your budget',
        content:
          'Learn more about the costs you can expect during the home buying process so you can budget accordingly.',
        buttons: [{ link: '/portal/budget/', text: 'Continue Planner' }],
      },
      PlannerCTAContent: {
        headline: 'Determine your budget',
        link: '/portal/budget/',
      },
    };
  }
  ///Land///
  else if (
    plannerProgress?.find((item) => item.section == 'Land')
      ?.percentCompleted !== 100
  ) {
    PlannerContent = {
      DashboardCTAContent: {
        label: 'Next Up',
        headline: 'Learn about land',
        content:
          'Understand how site preparation, permitting and purchasing land can impact your overall timeline.',
        buttons: [{ link: '/portal/land/', text: 'Continue Planner' }],
      },
      PlannerCTAContent: {
        headline: 'Learn about land',
        link: '/portal/land/',
      },
    };
  }
  ///Home Aspirations///
  else if (
    plannerProgress?.find((item) => item.section == 'Home Aspirations')
      ?.percentCompleted !== 100
  ) {
    PlannerContent = {
      DashboardCTAContent: {
        label: 'Next Up',
        headline: 'Home Aspirations',
        content:
          'Tell us more about what features, size and floor plan you imagine for your home so we can recommend homes near you.',
        buttons: [{ link: '/portal/planner/', text: 'Continue Planner' }],
      },
      PlannerCTAContent: {
        headline: 'Discover your home aspirations',
        link: '/portal/my-home-aspirations/',
      },
    };
  } else if (
    plannerProgress?.find((item) => item.section == 'Budget')
      ?.percentCompleted === 100 &&
    plannerProgress?.find((item) => item.section == 'Home Aspirations')
      ?.percentCompleted === 100 &&
    plannerProgress?.find((item) => item.section == 'Home Buying Journey')
      ?.percentCompleted === 100 &&
    plannerProgress?.find((item) => item.section == 'Land')
      ?.percentCompleted === 100
  ) {
    PlannerContent = {
      DashboardCTAContent: {
        label: 'Next Up',
        headline: 'Enjoy your personalized experience',
        content:
          'Now that you’ve completed the planner, browse homes that match your home preferences. Update your preferences anytime in your planner.',
        buttons: [
          { link: '/portal/homes-for-you/', text: 'Shop Your Preferences' },
          { link: '/portal/planner/', text: 'Edit Planner' },
        ],
      },
      PlannerCTAContent: null,
    };
  } else {
    PlannerContent = null;
  }

  return PlannerContent;
};

const getMonthName = (monthNumber) => {
  const date = new Date();
  date.setMonth(monthNumber - 1);

  return date.toLocaleString([], { month: 'long' });
};

export const setMoveDateFormat = (month, year) => {
  const namedMonth = month ? getMonthName(month) : null;

  if (month && year) {
    return `${namedMonth}, ${year} `;
  } else if (!month && year) {
    return 'No target date set';
  } else if (month && !year) {
    return 'No target date set';
  } else {
    return 'No target date set';
  }
};

export const fundingAnswer = (value) => {
  if (value == 'cash') {
    return 'I’m planning on purchasing with cash.';
  } else if (value == 'not_started') {
    return 'I need financing.';
  } else if (value == 'pre_approved') {
    return 'I’m pre-approved for financing.';
  } else {
    return 'You have not provided a budget';
  }
};

export const confidenceAnswer = (value) => {
  if (value == 'high') {
    return 'I think I get all of the pieces that make up the pie.';
  } else if (value == 'medium') {
    return 'I have a dollar amount I’m aiming for, but I don’t know all the things I need to plan for.';
  } else if (value == 'low') {
    return 'I have no idea where to start - I just know what houses I like!';
  } else {
    return 'You have not set a confidence level';
  }
};

export const landAnswer = (value, hasLand) => {
  if (hasLand === null) {
    return 'No answer provided';
  } else if (value == 'owned') {
    return 'Yep, it’s mine!';
  } else if (value == 'family') {
    return 'I have family land.';
  } else {
    return 'No - I would love some help!';
  }
};

export const findLandHomes = (homes) => {
  let landHomes;

  if (!homes) {
    return null;
  }

  landHomes = homes.filter(
    (home) => home.isLand == true || home.isOnLand == true
  );

  return landHomes;
};

export const findSaleHomes = (homes) => {
  let unSoldHomes;
  if (homes && homes.length > 0) {
    unSoldHomes = homes?.filter((x) => ![-1, 5].includes(x.stickerTypeId));
  }

  if (!homes) {
    return null;
  }

  const saleHomes = unSoldHomes?.filter(
    (home) => home.isSaleHome == true || home.isDefaultSaleHome == true
  );

  return saleHomes;
};

export const findBudgetHomes = (budget, homes) => {
  let unSoldHomes;
  if (homes && homes.length > 0) {
    unSoldHomes = homes?.filter((x) => ![-1, 5].includes(x.stickerTypeId));
  }

  if (!budget) {
    return null;
  }

  const budgetHomes = unSoldHomes?.filter((x) => x.priceSort <= budget);
  const sortedBudgetHomes = budgetHomes?.sort((a, b) => {
    return b.priceSort - a.priceSort;
  });

  return sortedBudgetHomes?.slice(0, 12);
};

export const findCombinedFilteredHomes = (
  budget,
  beds,
  baths,
  features,
  homes
) => {
  let unSoldHomes;
  if (homes && homes.length > 0) {
    unSoldHomes = homes?.filter((x) => ![-1, 5].includes(x.stickerTypeId));
  }

  let filteredHomesAll;
  let featureArray;
  if (features && features?.length > 0) {
    featureArray = features?.map((f) => f.name);
  }

  filteredHomesAll = unSoldHomes?.filter((home) => {
    if (
      featureArray &&
      featureArray.length > 0 &&
      !featureArray.some((f) => home.modelFeatures.includes(f))
    ) {
      return false;
    }
    if (home.beds !== beds) {
      return false;
    }
    if (home.baths !== baths) {
      return false;
    }
    if (home.priceSort > budget) {
      return false;
    }
    return true;
  });

  return filteredHomesAll?.slice(0, 12);
};

export const findAspirationHomes = (beds, baths, features, homes) => {
  let unSoldHomes;
  if (homes && homes.length > 0) {
    unSoldHomes = homes?.filter((x) => ![-1, 5].includes(x.stickerTypeId));
  }

  let featureArray;
  if (features && features?.length > 0) {
    featureArray = features?.map((f) => f.name);
  }

  const filteredHomes =
    features && features?.length > 0
      ? unSoldHomes?.filter(
          (x) =>
            x.beds == beds &&
            x.baths == baths &&
            featureArray?.some((f) => x.modelFeatures.includes(f))
        )
      : unSoldHomes?.filter((x) => x.beds == beds && x.baths == baths);

  return filteredHomes?.slice(0, 12);
};

export const findBedBathHomes = (beds, baths, homes) => {
  let unSoldHomes;
  if (homes && homes.length > 0) {
    unSoldHomes = homes?.filter((x) => ![-1, 5].includes(x.stickerTypeId));
  }

  if (!beds && !baths) {
    return null;
  }

  const filteredHomes = unSoldHomes?.filter(
    (x) => x.beds == beds && x.baths == baths
  );

  if (!filteredHomes) {
    return null;
  }

  return filteredHomes.slice(0, 12);
};

export const findFavoriteHomes = (favoriteList, homes) => {
  let unSoldHomes;
  if (homes && homes.length > 0) {
    unSoldHomes = homes?.filter((x) => ![-1, 5].includes(x.stickerTypeId));
  }

  let filteredHomes;

  filteredHomes = unSoldHomes?.filter((home) => {
    return favoriteList?.some((favorite) => {
      return (
        favorite.modelNumber === home.modelNumber &&
        favorite.serialNumber === home.serialNumber
      );
    });
  });

  if (!filteredHomes) {
    return null;
  }

  return filteredHomes;
};

const intToString = (num) => {
  num = num.toString().replace(/[^0-9.]/g, '');
  if (num < 1000) {
    return num;
  }
  let si = [
    { v: 1e3, s: 'k' },
    { v: 1e6, s: 'm' },
    { v: 1e9, s: 'b' },
    { v: 1e12, s: 't' },
    { v: 1e15, s: 'p' },
    { v: 1e18, s: 'e' },
  ];
  let index;
  for (index = si.length - 1; index > 0; index--) {
    if (num >= si[index].v) {
      break;
    }
  }
  return (
    (num / si[index].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') +
    si[index].s
  );
};

export const roundBudgetNumber = (budget) => {
  let roundedNum = Math.round(budget / 1000) * 1000;
  let roundedString = intToString(roundedNum);

  return roundedString;
};

export const createBedBathHeading = (beds, baths) => {
  let headline = '';

  if (beds && baths) {
    headline =
      beds +
      (beds == 1 ? ' Bed, ' : ' Beds, ') +
      baths +
      (baths == 1 ? ' Bath' : ' Baths');
  } else if (beds && !baths) {
    headline = beds + (beds == 1 ? ' Bed' : ' Beds');
  } else if (!beds && baths) {
    headline = baths + (baths == 1 ? ' Bath' : ' Baths');
  }

  return headline;
};

const createFeatureHeadline = (feature) => {
  if (feature == 'Computer Station / Computer Nook') {
    feature = 'Computer Station';
  }
  if (feature == 'Covered Porch / Covered Entry') {
    feature = 'Covered Porch';
  }
  if (feature == 'Kitchen Island / Cooking Island') {
    feature = 'Kitchen Island';
  }
  let arrayOne = [
    'Bonus Room',
    'Breakfast Bar',
    'Computer Station',
    'Covered Porch',
    'Dining Room',
    'Breakfast Bar',
    'Family Room',
    'Fireplace',
    'Foyer',
    'Kitchen Island',
    'Nursery',
    'Pantry',
    'Primary Bedroom Retreat',
    'Seperate Tub and Shower',
    'Utility Room',
  ];
  let arrayTwo = ['Office', 'Entertainment Unit', 'Open Floor Plan'];
  let arrayThree = ['Move-In Ready', '1 1/2 Story', 'Two Story', 'Crossmod'];

  if (arrayOne.includes(feature)) {
    return 'Homes with a ' + feature;
  } else if (arrayTwo.includes(feature)) {
    return 'Homes with an ' + feature;
  } else if (arrayThree.includes(feature)) {
    return 'Homes that are ' + feature;
  } else {
    return 'Homes with ' + feature;
  }
};

export const getFeaturesContent = (features, homes) => {
  let unSoldHomes;

  if (homes && homes.length > 0) {
    unSoldHomes = homes?.filter((x) => ![-1, 5].includes(x.stickerTypeId));
  }

  let featuresContentArray = [];
  let featuredHomes;
  let finalFeaturedHomes;

  if (!features || features?.length == 0) {
    return null;
  } else {
    features.forEach(function (feature, i) {
      featuredHomes = unSoldHomes?.filter((h) =>
        h.modelFeatures.includes(feature.name)
      );
      finalFeaturedHomes = featuredHomes
        ?.map((item) => {
          return {
            id: item.serialNumber || item.modelNumber,
            retailHomeObject: {
              ...item,
            },
          };
        })
        ?.slice(0, 12);
      featuresContentArray.push({
        id: 'featureId-' + i,
        headline: createFeatureHeadline(feature.name),
        homesList: finalFeaturedHomes,
      });
    });
    return featuresContentArray;
  }
};

export const isPlannerComplete = (progress) => {
  if (!progress) {
    return null;
  }

  const questions = [].concat(
    ...progress.map((s) =>
      s.contents?.filter((item) => item?.type == 'question')
    )
  );
  const allQuestionsAnswered = questions?.every((q) => q.isCompleted === true);

  return allQuestionsAnswered;
};

export const getTotalAverageProgress = (progress) => {
  let numArray = [];
  let finalAvg;
  if (!progress) {
    return null;
  }

  progress.forEach(function (item, i) {
    numArray.push(item.percentCompleted);
  });

  finalAvg =
    numArray.length > 0
      ? numArray?.reduce((a, b) => a + b) / numArray?.length
      : null;

  return finalAvg;
};

export const getEAppPin = (dealerId) => {
  let pin;
  if (dealerId) {
    pin = (3 * dealerId * dealerId + 12384).toString(16);
  }
  return pin;
};
